import { createApp } from "vue/dist/vue.esm-bundler";
import TabTable from "./components/TabTable.vue";

const tableContainers = document.querySelectorAll(".js-table-app");
const toggleClasses = new Set();
Array.prototype.forEach.call(tableContainers, (el) => {
  const app = createApp({
    delimiters: ["${", "}"],
    components: {
      TabTable,
    },
  });
  app.mount(el);

  //gather toggle-class
  toggleClasses.add(el.dataset.toggleClass);
});

//Loop through all the toggle classes
toggleClasses.forEach((c) => {
  const details = document.querySelectorAll("." + c);

  // Add the onclick listeners to each group
  details.forEach((targetDetail) => {
    targetDetail.addEventListener("click", () => {
      // Close all the details that are not targetDetail.
      details.forEach((detail) => {
        if (detail !== targetDetail) {
          detail.removeAttribute("open");
        }
      });
    });
  });
});
